import { HOME_MARK_SPACE_VISITED_FROM_HOME } from '@core/constants/actions';
import { HomeViewRole } from '@app/constants/home';

const markHomeSpaceVisitedFromHome = (spaceId: string, role: HomeViewRole) => ({
  type: HOME_MARK_SPACE_VISITED_FROM_HOME,
  spaceId,
  role,
});

export default markHomeSpaceVisitedFromHome;
